export default __webpack_public_path__ + "static/media/tela_saasbackup.59546fb2.png";